import GridResp1c_2c from "./GridResp1c_2c"

export default GridResp1c_2c
